//todo: use strings after DB structure changes
export enum MatchRefereeRoleEnum {
  Principal= 'Principal',
  Assistant = 'Assistant',
  Referee4th = 'Referee4th',
  Additional = 'Additional'
}

export const allMatchRefereeRoles = Object.keys(MatchRefereeRoleEnum);
